import { render, staticRenderFns } from "./8groupItem.vue?vue&type=template&id=74674b8b&scoped=true&"
import script from "./8groupItem.vue?vue&type=script&lang=js&"
export * from "./8groupItem.vue?vue&type=script&lang=js&"
import style0 from "./8groupItem.vue?vue&type=style&index=0&id=74674b8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74674b8b",
  null
  
)

export default component.exports